/**
 * Создание события, при котором яндекс-карта загружена полностью.
 */
export function loadYandexMap() {
    let mapOnload = new CustomEvent("maponload");

    document.dispatchEvent(mapOnload);
}  

window.loadYandexMap = loadYandexMap;